import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Toolbar as CustomToolbar } from './compenents';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    '& .ql-toolbar.ql-snow': {
      border: 'none',
      borderTop: '1px solid #eee',
      borderBottom: '1px solid #eee',
      // paddingTop: 0
    },
    '& .quill': {
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column'
    },
    '& .ql-container.ql-snow': {
      border: 'none',
      borderBottom: '1px solid #eee',
      flexGrow: 1
    }
  }
}));

const Size = Quill.import('formats/size');
Size.whitelist = ['extra-small', 'small', 'medium', 'large'];
Quill.register(Size, true);

// Add fonts to whitelist and register them
const Font = Quill.import('formats/font');
Font.whitelist = [
  'arial',
  'comic-sans',
  'courier-new',
  'georgia',
  'helvetica',
  'lucida'
];
Quill.register(Font, true);

function Editor({ handleUpload, className, ...rest }) {
  const classes = useStyles();

  const modules = {
    toolbar: {
      container: '#toolbar'
    }
  };

  const formats = [
    'size',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'align',
    'color',
    'background',
    'link',
    'image',
    'header',
    'font',
    'indent'
  ];

  return (
    <div
      className={clsx(classes.root, className)}
      data-text-editor="name"
    >
      <CustomToolbar handleUpload={handleUpload} />
      <ReactQuill
        {...rest}
        bounds="[data-text-editor='name']"
        formats={formats}
        modules={modules}
      />
    </div>
  );
}

Editor.propTypes = {
  className: PropTypes.string,
  handleUpload: PropTypes.func,
};

export default Editor;
